import { takeLatest, call, put, select } from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  updateFlightInAgentTipRequest,
  updateFlightInAgentTipResponse,
} from '../../slices/intelligence';

const queryString = require('query-string');

function* updateFlightInAgentTipWorker({
  payload: { cruiseItineraryId, agentTipId, flightOriginGeoIndex, betterFlight },
}) {
  try {
    const staterooms = yield select((state) => state.tripSearch.searchObj.staterooms);
    const { currencyCode } = yield select((store) => store.tripSearch);
    const { travelAgency } = yield select((store) => store.user);
    const doUseUSDForFlightRate =
      travelAgency && travelAgency.settings && travelAgency.settings.useUSDForFlightRate;

    const qs = queryString.stringify(
      {
        adults: _.sumBy(staterooms, (st) => st.adults || 0),
        seniors: _.sumBy(staterooms, (st) => st.seniors || 0),
        lapInfants: _.sumBy(staterooms, (st) => st.lapInfants || 0),
        seatInfants: _.sumBy(staterooms, (st) => st.seatInfants || 0),
        childrenAge: _.flatMap(staterooms, (st) => Object.values(st.children || [])),
        currencyCode: !doUseUSDForFlightRate && currencyCode ? currencyCode : undefined,
      },
      { skipNull: true },
    );

    const url = `/flights/findAgentTipBetterFlight?${qs}`;

    const bodyFlight = {
      origin: betterFlight.origin,
      destination: betterFlight.destination,
      outDepartureDate: betterFlight.outDepartureDate,
      outArrivalDate: betterFlight.outArrivalDate,
      inDepartureDate: betterFlight.inDepartureDate,
      inArrivalDate: betterFlight.inArrivalDate,
      lowestFare: betterFlight.lowestFare,
      lowestNonStopFare: betterFlight.lowestNonStopFare,
      outNumStops: betterFlight.outNumStops,
      inNumStops: betterFlight.inNumStops,
      airlineCodes: betterFlight.airlineCodes,
    };

    const config = {
      method: 'post',
      url,
      data: JSON.stringify(bodyFlight),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = yield call(axios, config);

    if (data) {
      yield put(
        updateFlightInAgentTipResponse({
          cruiseItineraryId,
          flightOriginGeoIndex,
          agentTipId,
          response: data,
        }),
      );
    } else {
      yield put(
        updateFlightInAgentTipResponse({
          cruiseItineraryId,
          flightOriginGeoIndex,
          agentTipId,
        }),
      );
    }
  } catch (error) {
    yield put(
      updateFlightInAgentTipResponse({
        cruiseItineraryId,
        flightOriginGeoIndex,
        agentTipId,
      }),
    );
  }
}

function* updateFlightInAgentTipWatcher() {
  yield takeLatest(updateFlightInAgentTipRequest.toString(), updateFlightInAgentTipWorker);
}

export default updateFlightInAgentTipWatcher;
